/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro";
import {
    DeleteMusicPieceMutation,
    DeleteMusicPieceMutation$variables
} from "mutation/__generated__/DeleteMusicPieceMutation.graphql";
import perform from "mutation/perform";

const mutation = graphql`
    mutation DeleteMusicPieceMutation($input: MusicDeletePieceInput!) {
        music_delete_piece(input: $input) {
            piece {
                id
                deleted
            }
        }
    }
`;

export default function DeleteMusicPiece(pieceId: string) {
    const variables: DeleteMusicPieceMutation$variables = {
        input: {
            piece_id: pieceId
        }
    }
    return perform<DeleteMusicPieceMutation>(mutation, variables);
}